import GalleryBottomContainer from './galleryBottomContainer'
export default GalleryBottomContainer
